import React from "react";
import PropTypes from "prop-types";
import { Select } from "@sainsburys-tech/fable";
import DingoEnergyChart from "../DingoEnergyChart/";
import { Event } from "../Tracking";

const DeviceEnergyChart = props => {
  const sensor = props.sensors.find(s => s.sensorId === props.sensorId);

  return [
    <Select
      key="sensor-selector"
      label="Select Sensor"
      hasHiddenLabel={true}
      name="sensors"
      options={mapSensorsToDropdownList(props.sensors)}
      placeholder={{ label: "Select a sensor", isDisabled: true }}
      value={props.sensorId}
      onChange={(value) => {
        Event("Sensor Selector Event", sensor.name, value);
        props.onSensorChange(value);
      }}
      className="cb-c-device-energy-chart__sensor-list"
    />,
    <DingoEnergyChart
      key="energy-chart"
      showSeriesLabel={false}
      sensor={sensor}
      window="W"
      {...props}
      sensorId={sensor.dingoId}
    />
  ];
};

const mapSensorsToDropdownList = sensors =>
  sensors.map(sensor => {
    return {
      value: sensor.sensorId,
      label: sensor.name,
      unit: sensor.unit
    };
  });

DeviceEnergyChart.propTypes = {
  onSensorChange: PropTypes.func.isRequired
};

export default DeviceEnergyChart;
